module.exports = __webpack_public_path__ + "static/media/items in the same color.7f65f9ba.mp3";